export const FILTER_EFFECTS_OPTIONS = [
  {
    value: 'colour',
    label: 'Original',
  },
  {
    value: 'greyscale',
    label: 'Black & White',
  },
  {
    value: 'sepia',
    label: 'Sepia',
    // }, {
    //   value: 'bluetone',
    //   label: 'Bluetone'
    // }, {
    //   value: 'lark',
    //   label: 'Sunshine'
    // }, {
    //   value: 'clarendon',
    //   label: 'Clarity'
    // }, {
    //   value: 'juno',
    //   label: 'Saturate'
    // }, {
    //   value: 'lofi',
    //   label: 'Memories'
    // }, {
    //   value: 'aden',
    //   label: 'Depth'
    // }, {
    //   value: 'gingham',
    //   label: 'Faded'
    // }, {
    //   value: 'ludwig',
    //   label: 'Warmth'
    // }, {
    //   value: 'toaster',
    //   label: 'Burn'
  },
];
